<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Relatório de Contas CSV</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="action-container">
      <p class="report-desc">
        Ao clicar no botão "Baixar CSV", o sistema gera um arquivo CSV com informações consolidadas de contas. 
        Ao selecionar um mês, caso seja o mês atual, o sistema inclui o mês atual até o dia de hoje e exibe os 12 meses 
        retroativos anteriores. Caso seja um mês anterior, o sistema inclui todo o mês selecionado
        (janela móvel de um ano).
      </p>

      <form [formGroup]="reportForm" class="field-container">
        <div class="filter-field">
          <div class="month-picker-wrapper" (click)="openPicker(monthPicker)">
            <span class="month-icon">📅</span>
              <input
                  #monthPicker
                  type="month"
                  formControlName="month"
                  class="hidden-month-input"
                  [attr.max]="maxMonth"
                  (change)="reportForm.get('month')?.setValue($event.target.value)"
                />
                <input
                  type="text"
                  [value]="formattedMonth"
                  class="month-text-input"
                  readonly
                />
          </div>
        </div>

        <button
          mat-raised-button
          type="button"
          class="btn-fixed download-btn"
          (click)="onDownloadCsv()"
          [disabled]="reportForm.invalid || isLoadingCsv"
        >
          Baixar CSV
        </button>
      </form>

      <div class="overlay" *ngIf="isLoadingCsv">
        <mat-spinner [diameter]="60"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
